let defaultString = `# Markdown Previewer

This is example what \`.md\` file could contain. Made as a part of [freeCodeCamp](https://www.freecodecamp.org/) project.

## Made using marked library

![alt text](https://marked.js.org/img/logo-black.svg "Marked")

\`\`\`javascript
import marked from "marked";
marked(input);
\`\`\`
## About marked

- ⚡ built for **speed**
- ⬇️ low-level compiler for parsing markdown without caching or blocking for long periods of time
- ⚖️ light-weight while implementing all markdown features from the supported flavors & specifications
- 🌐 works in a browser, on a server, or from a command line interface (CLI)

> blockquote`;

export { defaultString as default };
